import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { PayoutCard } from "./PayoutCard";
import { Col, Row, Spinner, Form } from "react-bootstrap";
import "./Payout.scss";
import { useDispatch, useSelector } from "react-redux";
import {
  payoutList,
  createPayout,
} from "../../../redux/actions/dbactions/payoutActions";
import { Header } from "../../Header";
import PayoutIcon from "../../../../assets/PayoutIcon";

const Payout = ({ searchQuery }) => {
  const dispatch = useDispatch();
  const { payout, isLoading } = useSelector((state) => state.payoutlist);
  const [selectedProfiles, setSelectedProfiles] = useState([]);
  const [refresh, setRefresh] = useState(true);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  useEffect(() => {
    if (refresh) {
      dispatch(payoutList());
      setRefresh(false);
    }
  }, [dispatch, refresh]);

  const handleCheckboxChange = (svcf_user_profile_id, checked) => {
    setSelectedProfiles((prevSelected) => {
      if (checked) {
        // Add svcf_user_profile_id to the list
        return [...prevSelected, svcf_user_profile_id];
      } else {
        // Remove svcf_user_profile_id from the list
        return prevSelected.filter((id) => id !== svcf_user_profile_id);
      }
    });
  };

  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
  };

  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
    // Dispatch action with startDate and endDate
    dispatch(payoutList({ startDate, endDate: e.target.value }));
  };
  const handleSubmitPayouts = () => {
    // Dispatch action with startDate and endDate

    dispatch(createPayout({ payoutlist: selectedProfiles }));
    setRefresh(true);
  };
  //const filteredValues = payout?.usr?.rec[0]?.daily_orders;
  const filteredValues = payout?.usr?.rec;

  return (
    <div>
      <Header pageTitle="Payout Details" icon={<PayoutIcon />} />

      <div className="px-[0.75rem] sm:px-8 mt-4 flex items-center justify-between mb-3">
        <h5 className="text-base sm:text-[26px] w-full whitespace-nowrap m-0">
          Payout
        </h5>
        <div className="w-fit whitespace-nowrap">
          {selectedProfiles.length > 0 ? (
            <button className="!text-xs sign_btn" onClick={handleSubmitPayouts}>
              + Submit Payouts
            </button>
          ) : null}
        </div>
      </div>

      <div className="sm:!px-8 !px-4 date-picker-container ">
        <Form className="mb-4">
          <Row>
            <Col>
              <Form.Group controlId="startDate">
                <Form.Label>Start Date</Form.Label>
                <Form.Control
                  type="date"
                  value={startDate}
                  onChange={handleStartDateChange}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group controlId="endDate">
                <Form.Label>End Date</Form.Label>
                <Form.Control
                  type="date"
                  value={endDate}
                  onChange={handleEndDateChange}
                />
              </Form.Group>
            </Col>
          </Row>
        </Form>
      </div>
      {isLoading ? (
        <div className="text-center">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : null}
      <Row className="sm:px-4 m-0">
        {filteredValues?.length > 0 ? (
          filteredValues?.map((item, index) => (
            <Col className="mb-3" lg={4} md={6} key={index}>
              <PayoutCard
                data={item}
                key={item.svcf_user_profile_id}
                onCheckboxChange={handleCheckboxChange}
                isSelected={selectedProfiles.includes(
                  item.svcf_user_profile_id
                )}
              />
            </Col>
          ))
        ) : (
          <Col>
            <p className="text-center">No Payouts to display</p>
          </Col>
        )}
      </Row>
    </div>
  );
};

export default withRouter(Payout);
